<template>
  <div class="box box-success">
    <div class="box-body">
      <div class="col-md-12">
        <div class="row">
          <div class="form-group">
            <button
              type="button"
              class="btn btn-labeled btn-primary pull-right"
              @click="onAddNewService"
              style="margin-right: 5px;"
            >
              <span class="btn-label"> <i class="fa fa-plus"></i> </span>
              {{ $t("common.addnew") }}
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-12" style="margin-top: 15px">
        <b-table striped hover :items="productItems" :fields="productFields">
          <template #head()="scope">
            <div class="">{{ $t(scope.label) }}</div>
          </template>
          <template #head(showOnMobile)>
            <i class="fa fa-mobile" aria-hidden="true" style="font-size: xx-large;"></i>
          </template>
          <template #cell(showOnMobile)="row">
            <i
              v-if="row.item.showOnMobile"
              style="font-size: x-large; color: green"
              class="glyphicon glyphicon-ok-sign"
            ></i>
            <i
              v-else
              style="font-size: x-large; color: red"
              class="glyphicon glyphicon-remove-sign"
            ></i>
          </template>
          <template #cell(serviceUnit)="row">
            {{ (row.item.serviceUnit) }}
          </template>
          <template #cell(serviceGroup)="row">
            {{ getProductGroupName(row.item.serviceGroup) }}
          </template>
          <template #cell(imgUrl)="row">
            <img
              class="asset-img-class img-responsive"
              :src="row.item.imgUrl"
              alt=""
              @click="onViewImgNewTab(row.item.imgUrl)"
            />
          </template>
          <template #cell(enable)="row">
            <div style="text-align: center">
              <i
                v-if="row.item.enable"
                style="font-size: x-large; color: green"
                class="glyphicon glyphicon-ok-sign"
              ></i>
              <i
                v-else
                style="font-size: x-large; color: red"
                class="glyphicon glyphicon-remove-sign"
              ></i>
            </div>
          </template>
          <template #cell(actions)="row">
            <div class="btn-group">
              <button
                type="button"
                class="btn btn-danger dropdown-toggle"
                data-toggle="dropdown"
                aria-expanded="true"
              >
                <i class="fa fa-fw fa-ellipsis-h"></i>
              </button>
              <ul class="dropdown-menu" style="min-width: 50px">
                <li>
                  <button
                    v-if="
                      GET_ACCOUNT_DATA.group_id == 1 || has_perm('update_service')
                    "
                    class="btn btn-primary btn-sm"
                    style="margin-left: 6px;"
                    :title="$t('common.modify')"
                    @click="onUpdateService(row.item)"
                  >
                    <i class="glyphicon glyphicon-edit"></i>
                  </button>
                </li>
                <li style="margin-top: 5px">
                  <button
                    v-if="(GET_ACCOUNT_DATA.group_id == 1 || has_perm('update_service')) && !row.item.isBuiltin"
                    class="btn btn-info btn-sm"
                    style="margin-left: 6px;"
                    :title="$t('service.servicePackage.title')"
                    @click="onOpenServicePackageModal(row.item)"
                  >
                    <i class="glyphicon glyphicon-book"></i>
                  </button>
                </li>
                <li style="margin-top: 5px">
                  <button
                    v-if="(GET_ACCOUNT_DATA.group_id == 1 || has_perm('delete_service')) && !row.item.isBuiltin"
                    class="btn btn-danger btn-sm"
                    style="margin-left: 6px;"
                    :title="$t('common.delete')"
                    @click="onOpenDelete(row.item)"
                  >
                    <i class="glyphicon glyphicon-trash"></i>
                  </button>
                </li>
              </ul>
            </div>
          </template>
        </b-table>
        <div class="box-footer clearfix" style="display:contents;">
          <custom-paginator
            :totalItem="paginateData.totalItem"
            :currentPage="paginateData.currentPage"
            :pageSize="paginateData.pageSize"
            :totalPage="paginateData.totalPage"
            @onpaginate="onCustomPagination"
          />
        </div>
      </div>
    </div>
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="onConfirm"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
    <!--  -->
    <service-detail
      ref="serviceDetail"
      @callbackGetService="callbackGetService"
    />
    <service-package-modal ref="servicePackageModal" @callbackServiceList="callbackGetService"/>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import LTEModal from "@/components/LTEModal.vue";
import ServiceDetail from "./ApartmentServiceDetail.vue";
import CustomPaginator from "@/components/CustomPaginator.vue";
import servicePackageModal from "./ServicePackageModal.vue"
// import Enum from "../../../enum/enum";
import utils from "@/lib/utils";

export default {
  components: {
    "lte-modal": LTEModal,
    ServiceDetail,
    CustomPaginator,
    servicePackageModal
  },
  data: () => ({
    productFields: [
      {
        key: "nonumber",
        label: "common.nonumber",
        class: "text-center"
      },
      {
        key: "imgUrl",
        label: "banner.image",
        class: "text-center"
      },
      {
        key: "serviceCode",
        label: "service.service_code"
      },
      {
        key: "serviceName",
        label: "service.serviceList.serviceName"
      },
      {
        key: "numberOfPackage",
        label: "service.numberOfPackage",
        class: "text-center"
      },
      {
        key: "serviceUnit",
        label: "service.serviceUnit"
      },
      // {
      //   key: "serviceGroup",
      //   label: "service.serviceGroup"
      // },
      {
        key: "enable",
        label: "common.enable",
        class: "text-center"
      },
      {
        key: "showOnMobile",
        label: "common.enable",
        class: "text-center"
      },
      // {
      //   key: "serviceDescription",
      //   label: "product.productList.productDescription"
      // },
      {
        key: "actions",
        label: "common.action",
        class: "text-center"
      }
    ],
    productItems: [],
    isModalVisible: false,
    originalRecordData: null,
    objModal: [
      {
        title: "common.delete_modal.title",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    serviceGroupList: [],
    serviceUnitList: [],
    isShowOnMobile: false
  }),
  watch: {
    GET_SERVICE_LIST_V2_DATA: function() {
      let paginate = this.GET_SERVICE_LIST_V2_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      let data = this.GET_SERVICE_LIST_V2_DATA.results;
      this.productItems = [];
      data.forEach((value, index) => {
        let nonumber =
          index +
          1 +
          (this.paginateData.currentPage - 1) * this.paginateData.pageSize;
        let item = {
          id: value.id,
          nonumber: nonumber,
          serviceCode: value.servicecode,
          serviceName: value.name,
          // productGroupName: '',
          serviceGroup: value.service_group,
          // productUnitName: '',
          serviceUnit: value.service_unit,
          serviceDescription: value.description,
          serviceType: value.type,
          enable: value.enable,
          imgUrl: value.img_url,
          numberOfPackage: value.is_builtin ? null : value.service_package_count,
          iconMobile: value.icon_mobile_url,
          isUpdateShowOnMobile: value.is_update_show_on_mobile,
          showOnMobile: value.show_default_in_mobile,
          isBuiltin: value.is_builtin
        };
        this.isShowOnMobile = value.is_update_show_on_mobile
        this.productItems.push(item);
      });
    },
    GET_SERVICE_GROUP_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_SERVICE_GROUP_LIST_NO_PAGE_DATA;
      this.serviceGroupList = [];
      data.forEach(value => {
        let item = {
          id: value.id,
          productGroupName: value.name,
          description: value.description
        };
        this.serviceGroupList.push(item);
      });
    },
    GET_SERVICE_UNIT_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_SERVICE_UNIT_LIST_NO_PAGE_DATA;
      this.serviceUnitList = [];
      data.forEach(value => {
        let item = {
          id: value.id,
          serviceUnit: value.name,
          description: value.description
        };
        this.serviceUnitList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_SERVICE_LIST_V2_DATA",
      "GET_SERVICE_GROUP_LIST_NO_PAGE_DATA",
      "GET_SERVICE_UNIT_LIST_NO_PAGE_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onAddNewService: function() {
      this.$refs.serviceDetail.onShowAddNew(this.isShowOnMobile);
    },
    onUpdateService: function(data) {
      this.$refs.serviceDetail.onShowDetail(data);
    },
    onViewImgNewTab: function(data) {
      window.open(data);
    },
    onOpenDelete: function(data) {
      this.originalRecordData = data;
      this.isModalVisible = true;
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_SERVICE_V2(this.originalRecordData)
        .then(
          function() {
            this.callbackGetService();
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    closeModal() {
      this.isModalVisible = false;
    },
    getProductList: function(page) {
      let filter = {
        params: {
          page: page
        }
      };
      this.GET_SERVICE_LIST_V2(filter);
    },
    onCallbackData: async function() {
      await this.getProductGroup();
      await this.getServiceUnit();
      await this.getProductList(1);
    },
    callbackGetService: function() {
      this.getProductList(this.paginateData.currentPage);
    },
    onCustomPagination: function(data) {
      this.paginateData.currentPage = data;
      this.getProductList(data);
    },
    getProductGroup: function() {
      this.GET_SERVICE_GROUP_LIST();
    },
    getServiceUnit: function() {
      this.GET_SERVICE_UNIT_LIST();
    },
    getProductGroupName: function(value) {
      let result = "";
      let index = this.serviceGroupList.findIndex(x => x.id === value);
      if (index !== -1) {
        result = this.serviceGroupList[index].productGroupName;
      }
      return result;
    },
    getProductUnitName: function(value) {
      let result = "";
      let index = this.serviceUnitList.findIndex(x => x.id === value);
      if (index !== -1) {
        result = this.serviceUnitList[index].serviceUnit;
      }
      return result;
    },
    onOpenServicePackageModal: function(data) {
      this.$refs.servicePackageModal.onShowModal(data.id, this.getProductUnitName(data.serviceUnit))
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "GET_SERVICE_LIST_V2",
      "DELETE_SERVICE_V2",
      "GET_SERVICE_GROUP_LIST",
      "GET_SERVICE_UNIT_LIST",
      "GET_TOKEN_UPLOAD"
    ])
  },
  async mounted() {
    await this.getProductList(1);
    await this.getProductGroup();
    await this.getServiceUnit();
    await this.GET_TOKEN_UPLOAD();
  }
};
</script>
<style scoped>
.asset-img-class {
  width: 100%;
  max-width: 75px;
  max-height: 45px;
  object-fit: contain;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Service/ApartmentServiceList.vue